import Cookies from "js-cookie";
import {
  OperationSchema
} from "../../features/calculator/validators/validators";
async function parseJSON(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { raw: text };
  }
}
function toHeaders(csrfToken) {
  const h = { "Content-Type": "application/json" };
  if (csrfToken) h["X-CSRFToken"] = csrfToken;
  return h;
}
function normalizeOperation(dto) {
  return {
    marketDetails: {
      ...dto.marketDetails,
      time_expiration: new Date(dto.marketDetails.time_expiration)
    },
    marketOperations: dto.marketOperations
  };
}
const BASE = "https://arbitragem.bet:3131/calculator";
async function createOperation(op, csrfToken) {
  const b4726486 = Cookies.get("b4726486");
  const body = JSON.stringify({
    marketDetails: {
      ...op.marketDetails,
      // send as ISO for DRF DateTimeField
      time_expiration: op.marketDetails.time_expiration.toISOString()
    },
    marketOperations: op.marketOperations,
    b4726486
  });
  try {
    const res = await fetch(`${BASE}/operations/`, {
      method: "POST",
      headers: toHeaders(csrfToken),
      body
    });
    const data = await parseJSON(res);
    if (!res.ok) {
      return {
        ok: false,
        status: res.status,
        message: data?.message ?? "Request failed",
        details: data?.errors ?? data
      };
    }
    const parsed = OperationSchema.safeParse(data);
    if (!parsed.success) {
      return {
        ok: false,
        status: res.status,
        message: "Unexpected response shape.",
        details: parsed.error.format()
      };
    }
    return {
      ok: true,
      data: normalizeOperation(parsed.data),
      status: res.status
    };
  } catch (e) {
    return { ok: false, status: 0, message: e?.message ?? "Network error" };
  }
}
async function getOperationByPartLink(part_link) {
  try {
    const res = await fetch(
      `${BASE}/operations/${encodeURIComponent(part_link)}/read/`,
      {
        method: "GET"
      }
    );
    const data = await parseJSON(res);
    if (!res.ok) {
      return {
        ok: false,
        status: res.status,
        message: data?.message ?? "Request failed",
        details: data?.errors ?? data
      };
    }
    const parsed = OperationSchema.safeParse(data);
    if (!parsed.success) {
      return {
        ok: false,
        status: res.status,
        message: "Unexpected response shape.",
        details: parsed.error.format()
      };
    }
    return {
      ok: true,
      data: normalizeOperation(parsed.data),
      status: res.status
    };
  } catch (e) {
    return { ok: false, status: 0, message: e?.message ?? "Network error" };
  }
}
async function updateOperationByPartLink(currentPartLink, newData, csrfToken) {
  const b4726486 = Cookies.get("b4726486");
  const body = JSON.stringify({
    marketDetails: {
      ...newData.marketDetails,
      time_expiration: newData.marketDetails.time_expiration.toISOString()
    },
    marketOperations: newData.marketOperations,
    b4726486
  });
  try {
    const res = await fetch(
      `${BASE}/operations/${encodeURIComponent(currentPartLink)}/update/`,
      {
        method: "PUT",
        headers: toHeaders(csrfToken),
        body
      }
    );
    const data = await parseJSON(res);
    if (!res.ok) {
      return {
        ok: false,
        status: res.status,
        message: data?.message ?? "Request failed",
        details: data?.errors ?? data
      };
    }
    const parsed = OperationSchema.safeParse(data);
    if (!parsed.success) {
      return {
        ok: false,
        status: res.status,
        message: "Unexpected response shape.",
        details: parsed.error.format()
      };
    }
    return {
      ok: true,
      data: normalizeOperation(parsed.data),
      status: res.status
    };
  } catch (e) {
    return { ok: false, status: 0, message: e?.message ?? "Network error" };
  }
}
async function deleteOperationByPartLink(part_link, csrfToken) {
  const b4726486 = Cookies.get("b4726486");
  const body = JSON.stringify({ part_link, b4726486 });
  try {
    const res = await fetch(`${BASE}/operations/delete/`, {
      method: "POST",
      // matches your requirement
      headers: toHeaders(csrfToken),
      body
    });
    const data = await parseJSON(res);
    if (!res.ok) {
      return {
        ok: false,
        status: res.status,
        message: data?.message ?? "Request failed",
        details: data?.errors ?? data
      };
    }
    return {
      ok: true,
      data: { message: data?.message ?? "Operation deleted successfully." },
      status: res.status
    };
  } catch (e) {
    return { ok: false, status: 0, message: e?.message ?? "Network error" };
  }
}
async function getAllOperations() {
  const b4726486 = Cookies.get("b4726486");
  const body = JSON.stringify({ b4726486 });
  try {
    const res = await fetch(`${BASE}/operations/list/`, {
      method: "POST",
      headers: toHeaders(),
      body
    });
    const data = await parseJSON(res);
    if (!res.ok) {
      return {
        ok: false,
        status: res.status,
        message: data?.message ?? "Request failed",
        details: data?.errors ?? data
      };
    }
    return {
      ok: true,
      data,
      status: res.status
    };
  } catch (e) {
    return {
      ok: false,
      status: 0,
      message: e?.message ?? "Network error"
    };
  }
}
export {
  createOperation,
  deleteOperationByPartLink,
  getAllOperations,
  getOperationByPartLink,
  updateOperationByPartLink
};